webpackJsonp([0],{

/***/ "../../../node_modules/babel-runtime/core-js/array/from.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../../../node_modules/core-js/library/fn/array/from.js"), __esModule: true };

/***/ }),

/***/ "../../../node_modules/babel-runtime/core-js/get-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../../../node_modules/core-js/library/fn/get-iterator.js"), __esModule: true };

/***/ }),

/***/ "../../../node_modules/babel-runtime/core-js/is-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../../../node_modules/core-js/library/fn/is-iterable.js"), __esModule: true };

/***/ }),

/***/ "../../../node_modules/babel-runtime/core-js/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../../../node_modules/core-js/library/fn/object/assign.js"), __esModule: true };

/***/ }),

/***/ "../../../node_modules/babel-runtime/core-js/set-immediate.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../../../node_modules/core-js/library/fn/set-immediate.js"), __esModule: true };

/***/ }),

/***/ "../../../node_modules/babel-runtime/helpers/extends.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("../../../node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ "../../../node_modules/babel-runtime/helpers/slicedToArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__("../../../node_modules/babel-runtime/core-js/is-iterable.js");

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__("../../../node_modules/babel-runtime/core-js/get-iterator.js");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ "../../../node_modules/babel-runtime/helpers/toArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("../../../node_modules/babel-runtime/core-js/array/from.js");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
};

/***/ }),

/***/ "../../../node_modules/babel-runtime/helpers/toConsumableArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("../../../node_modules/babel-runtime/core-js/array/from.js");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ "../../../node_modules/core-js/library/fn/array/from.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../../../node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("../../../node_modules/core-js/library/modules/es6.array.from.js");
module.exports = __webpack_require__("../../../node_modules/core-js/library/modules/_core.js").Array.from;


/***/ }),

/***/ "../../../node_modules/core-js/library/fn/get-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../../../node_modules/core-js/library/modules/web.dom.iterable.js");
__webpack_require__("../../../node_modules/core-js/library/modules/es6.string.iterator.js");
module.exports = __webpack_require__("../../../node_modules/core-js/library/modules/core.get-iterator.js");


/***/ }),

/***/ "../../../node_modules/core-js/library/fn/is-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../../../node_modules/core-js/library/modules/web.dom.iterable.js");
__webpack_require__("../../../node_modules/core-js/library/modules/es6.string.iterator.js");
module.exports = __webpack_require__("../../../node_modules/core-js/library/modules/core.is-iterable.js");


/***/ }),

/***/ "../../../node_modules/core-js/library/fn/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../../../node_modules/core-js/library/modules/es6.object.assign.js");
module.exports = __webpack_require__("../../../node_modules/core-js/library/modules/_core.js").Object.assign;


/***/ }),

/***/ "../../../node_modules/core-js/library/fn/set-immediate.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../../../node_modules/core-js/library/modules/web.immediate.js");
module.exports = __webpack_require__("../../../node_modules/core-js/library/modules/_core.js").setImmediate;


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_a-function.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_add-to-unscopables.js":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../../../node_modules/core-js/library/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("../../../node_modules/core-js/library/modules/_to-iobject.js");
var toLength = __webpack_require__("../../../node_modules/core-js/library/modules/_to-length.js");
var toAbsoluteIndex = __webpack_require__("../../../node_modules/core-js/library/modules/_to-absolute-index.js");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_classof.js":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("../../../node_modules/core-js/library/modules/_cof.js");
var TAG = __webpack_require__("../../../node_modules/core-js/library/modules/_wks.js")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_cof.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_core.js":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_create-property.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("../../../node_modules/core-js/library/modules/_object-dp.js");
var createDesc = __webpack_require__("../../../node_modules/core-js/library/modules/_property-desc.js");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("../../../node_modules/core-js/library/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_defined.js":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("../../../node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../../../node_modules/core-js/library/modules/_is-object.js");
var document = __webpack_require__("../../../node_modules/core-js/library/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../../../node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("../../../node_modules/core-js/library/modules/_core.js");
var ctx = __webpack_require__("../../../node_modules/core-js/library/modules/_ctx.js");
var hide = __webpack_require__("../../../node_modules/core-js/library/modules/_hide.js");
var has = __webpack_require__("../../../node_modules/core-js/library/modules/_has.js");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_fails.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_global.js":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_has.js":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("../../../node_modules/core-js/library/modules/_object-dp.js");
var createDesc = __webpack_require__("../../../node_modules/core-js/library/modules/_property-desc.js");
module.exports = __webpack_require__("../../../node_modules/core-js/library/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_html.js":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("../../../node_modules/core-js/library/modules/_global.js").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("../../../node_modules/core-js/library/modules/_descriptors.js") && !__webpack_require__("../../../node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("../../../node_modules/core-js/library/modules/_dom-create.js")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_invoke.js":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("../../../node_modules/core-js/library/modules/_cof.js");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_is-array-iter.js":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("../../../node_modules/core-js/library/modules/_iterators.js");
var ITERATOR = __webpack_require__("../../../node_modules/core-js/library/modules/_wks.js")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_is-object.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_iter-call.js":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("../../../node_modules/core-js/library/modules/_an-object.js");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_iter-create.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("../../../node_modules/core-js/library/modules/_object-create.js");
var descriptor = __webpack_require__("../../../node_modules/core-js/library/modules/_property-desc.js");
var setToStringTag = __webpack_require__("../../../node_modules/core-js/library/modules/_set-to-string-tag.js");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("../../../node_modules/core-js/library/modules/_hide.js")(IteratorPrototype, __webpack_require__("../../../node_modules/core-js/library/modules/_wks.js")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_iter-define.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("../../../node_modules/core-js/library/modules/_library.js");
var $export = __webpack_require__("../../../node_modules/core-js/library/modules/_export.js");
var redefine = __webpack_require__("../../../node_modules/core-js/library/modules/_redefine.js");
var hide = __webpack_require__("../../../node_modules/core-js/library/modules/_hide.js");
var Iterators = __webpack_require__("../../../node_modules/core-js/library/modules/_iterators.js");
var $iterCreate = __webpack_require__("../../../node_modules/core-js/library/modules/_iter-create.js");
var setToStringTag = __webpack_require__("../../../node_modules/core-js/library/modules/_set-to-string-tag.js");
var getPrototypeOf = __webpack_require__("../../../node_modules/core-js/library/modules/_object-gpo.js");
var ITERATOR = __webpack_require__("../../../node_modules/core-js/library/modules/_wks.js")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_iter-detect.js":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("../../../node_modules/core-js/library/modules/_wks.js")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_iter-step.js":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_iterators.js":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_library.js":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_object-assign.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__("../../../node_modules/core-js/library/modules/_descriptors.js");
var getKeys = __webpack_require__("../../../node_modules/core-js/library/modules/_object-keys.js");
var gOPS = __webpack_require__("../../../node_modules/core-js/library/modules/_object-gops.js");
var pIE = __webpack_require__("../../../node_modules/core-js/library/modules/_object-pie.js");
var toObject = __webpack_require__("../../../node_modules/core-js/library/modules/_to-object.js");
var IObject = __webpack_require__("../../../node_modules/core-js/library/modules/_iobject.js");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("../../../node_modules/core-js/library/modules/_fails.js")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_object-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("../../../node_modules/core-js/library/modules/_an-object.js");
var dPs = __webpack_require__("../../../node_modules/core-js/library/modules/_object-dps.js");
var enumBugKeys = __webpack_require__("../../../node_modules/core-js/library/modules/_enum-bug-keys.js");
var IE_PROTO = __webpack_require__("../../../node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("../../../node_modules/core-js/library/modules/_dom-create.js")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("../../../node_modules/core-js/library/modules/_html.js").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("../../../node_modules/core-js/library/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("../../../node_modules/core-js/library/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("../../../node_modules/core-js/library/modules/_to-primitive.js");
var dP = Object.defineProperty;

exports.f = __webpack_require__("../../../node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_object-dps.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("../../../node_modules/core-js/library/modules/_object-dp.js");
var anObject = __webpack_require__("../../../node_modules/core-js/library/modules/_an-object.js");
var getKeys = __webpack_require__("../../../node_modules/core-js/library/modules/_object-keys.js");

module.exports = __webpack_require__("../../../node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_object-gops.js":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_object-gpo.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("../../../node_modules/core-js/library/modules/_has.js");
var toObject = __webpack_require__("../../../node_modules/core-js/library/modules/_to-object.js");
var IE_PROTO = __webpack_require__("../../../node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("../../../node_modules/core-js/library/modules/_has.js");
var toIObject = __webpack_require__("../../../node_modules/core-js/library/modules/_to-iobject.js");
var arrayIndexOf = __webpack_require__("../../../node_modules/core-js/library/modules/_array-includes.js")(false);
var IE_PROTO = __webpack_require__("../../../node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("../../../node_modules/core-js/library/modules/_object-keys-internal.js");
var enumBugKeys = __webpack_require__("../../../node_modules/core-js/library/modules/_enum-bug-keys.js");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_object-pie.js":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_property-desc.js":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_redefine.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../../../node_modules/core-js/library/modules/_hide.js");


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_set-to-string-tag.js":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("../../../node_modules/core-js/library/modules/_object-dp.js").f;
var has = __webpack_require__("../../../node_modules/core-js/library/modules/_has.js");
var TAG = __webpack_require__("../../../node_modules/core-js/library/modules/_wks.js")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("../../../node_modules/core-js/library/modules/_shared.js")('keys');
var uid = __webpack_require__("../../../node_modules/core-js/library/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("../../../node_modules/core-js/library/modules/_core.js");
var global = __webpack_require__("../../../node_modules/core-js/library/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("../../../node_modules/core-js/library/modules/_library.js") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_string-at.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("../../../node_modules/core-js/library/modules/_to-integer.js");
var defined = __webpack_require__("../../../node_modules/core-js/library/modules/_defined.js");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_task.js":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("../../../node_modules/core-js/library/modules/_ctx.js");
var invoke = __webpack_require__("../../../node_modules/core-js/library/modules/_invoke.js");
var html = __webpack_require__("../../../node_modules/core-js/library/modules/_html.js");
var cel = __webpack_require__("../../../node_modules/core-js/library/modules/_dom-create.js");
var global = __webpack_require__("../../../node_modules/core-js/library/modules/_global.js");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("../../../node_modules/core-js/library/modules/_cof.js")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("../../../node_modules/core-js/library/modules/_to-integer.js");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_to-integer.js":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("../../../node_modules/core-js/library/modules/_iobject.js");
var defined = __webpack_require__("../../../node_modules/core-js/library/modules/_defined.js");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("../../../node_modules/core-js/library/modules/_to-integer.js");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("../../../node_modules/core-js/library/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("../../../node_modules/core-js/library/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_uid.js":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/_wks.js":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("../../../node_modules/core-js/library/modules/_shared.js")('wks');
var uid = __webpack_require__("../../../node_modules/core-js/library/modules/_uid.js");
var Symbol = __webpack_require__("../../../node_modules/core-js/library/modules/_global.js").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/core.get-iterator-method.js":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("../../../node_modules/core-js/library/modules/_classof.js");
var ITERATOR = __webpack_require__("../../../node_modules/core-js/library/modules/_wks.js")('iterator');
var Iterators = __webpack_require__("../../../node_modules/core-js/library/modules/_iterators.js");
module.exports = __webpack_require__("../../../node_modules/core-js/library/modules/_core.js").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/core.get-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("../../../node_modules/core-js/library/modules/_an-object.js");
var get = __webpack_require__("../../../node_modules/core-js/library/modules/core.get-iterator-method.js");
module.exports = __webpack_require__("../../../node_modules/core-js/library/modules/_core.js").getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/core.is-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("../../../node_modules/core-js/library/modules/_classof.js");
var ITERATOR = __webpack_require__("../../../node_modules/core-js/library/modules/_wks.js")('iterator');
var Iterators = __webpack_require__("../../../node_modules/core-js/library/modules/_iterators.js");
module.exports = __webpack_require__("../../../node_modules/core-js/library/modules/_core.js").isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/es6.array.from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("../../../node_modules/core-js/library/modules/_ctx.js");
var $export = __webpack_require__("../../../node_modules/core-js/library/modules/_export.js");
var toObject = __webpack_require__("../../../node_modules/core-js/library/modules/_to-object.js");
var call = __webpack_require__("../../../node_modules/core-js/library/modules/_iter-call.js");
var isArrayIter = __webpack_require__("../../../node_modules/core-js/library/modules/_is-array-iter.js");
var toLength = __webpack_require__("../../../node_modules/core-js/library/modules/_to-length.js");
var createProperty = __webpack_require__("../../../node_modules/core-js/library/modules/_create-property.js");
var getIterFn = __webpack_require__("../../../node_modules/core-js/library/modules/core.get-iterator-method.js");

$export($export.S + $export.F * !__webpack_require__("../../../node_modules/core-js/library/modules/_iter-detect.js")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/es6.array.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("../../../node_modules/core-js/library/modules/_add-to-unscopables.js");
var step = __webpack_require__("../../../node_modules/core-js/library/modules/_iter-step.js");
var Iterators = __webpack_require__("../../../node_modules/core-js/library/modules/_iterators.js");
var toIObject = __webpack_require__("../../../node_modules/core-js/library/modules/_to-iobject.js");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("../../../node_modules/core-js/library/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/es6.object.assign.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("../../../node_modules/core-js/library/modules/_export.js");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("../../../node_modules/core-js/library/modules/_object-assign.js") });


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/es6.string.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("../../../node_modules/core-js/library/modules/_string-at.js")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("../../../node_modules/core-js/library/modules/_iter-define.js")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/web.dom.iterable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../../../node_modules/core-js/library/modules/es6.array.iterator.js");
var global = __webpack_require__("../../../node_modules/core-js/library/modules/_global.js");
var hide = __webpack_require__("../../../node_modules/core-js/library/modules/_hide.js");
var Iterators = __webpack_require__("../../../node_modules/core-js/library/modules/_iterators.js");
var TO_STRING_TAG = __webpack_require__("../../../node_modules/core-js/library/modules/_wks.js")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "../../../node_modules/core-js/library/modules/web.immediate.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("../../../node_modules/core-js/library/modules/_export.js");
var $task = __webpack_require__("../../../node_modules/core-js/library/modules/_task.js");
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),

/***/ "../../../node_modules/xstream/extra/concat.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var index_1 = __webpack_require__("../../../node_modules/xstream/index.js");
var ConcatProducer = (function () {
    function ConcatProducer(streams) {
        this.streams = streams;
        this.type = 'concat';
        this.out = null;
        this.i = 0;
    }
    ConcatProducer.prototype._start = function (out) {
        this.out = out;
        this.streams[this.i]._add(this);
    };
    ConcatProducer.prototype._stop = function () {
        var streams = this.streams;
        if (this.i < streams.length) {
            streams[this.i]._remove(this);
        }
        this.i = 0;
        this.out = null;
    };
    ConcatProducer.prototype._n = function (t) {
        var u = this.out;
        if (!u)
            return;
        u._n(t);
    };
    ConcatProducer.prototype._e = function (err) {
        var u = this.out;
        if (!u)
            return;
        u._e(err);
    };
    ConcatProducer.prototype._c = function () {
        var u = this.out;
        if (!u)
            return;
        var streams = this.streams;
        streams[this.i]._remove(this);
        if (++this.i < streams.length) {
            streams[this.i]._add(this);
        }
        else {
            u._c();
        }
    };
    return ConcatProducer;
}());
/**
 * Puts one stream after the other. *concat* is a factory that takes multiple
 * streams as arguments, and starts the `n+1`-th stream only when the `n`-th
 * stream has completed. It concatenates those streams together.
 *
 * Marble diagram:
 *
 * ```text
 * --1--2---3---4-|
 * ...............--a-b-c--d-|
 *           concat
 * --1--2---3---4---a-b-c--d-|
 * ```
 *
 * Example:
 *
 * ```js
 * import concat from 'xstream/extra/concat'
 *
 * const streamA = xs.of('a', 'b', 'c')
 * const streamB = xs.of(10, 20, 30)
 * const streamC = xs.of('X', 'Y', 'Z')
 *
 * const outputStream = concat(streamA, streamB, streamC)
 *
 * outputStream.addListener({
 *   next: (x) => console.log(x),
 *   error: (err) => console.error(err),
 *   complete: () => console.log('concat completed'),
 * })
 * ```
 *
 * @factory true
 * @param {Stream} stream1 A stream to concatenate together with other streams.
 * @param {Stream} stream2 A stream to concatenate together with other streams. Two
 * or more streams may be given as arguments.
 * @return {Stream}
 */
function concat() {
    var streams = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        streams[_i] = arguments[_i];
    }
    return new index_1.Stream(new ConcatProducer(streams));
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = concat;
//# sourceMappingURL=concat.js.map

/***/ }),

/***/ "../../../node_modules/xstream/extra/dropRepeats.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var index_1 = __webpack_require__("../../../node_modules/xstream/index.js");
var empty = {};
var DropRepeatsOperator = (function () {
    function DropRepeatsOperator(ins, fn) {
        this.ins = ins;
        this.fn = fn;
        this.type = 'dropRepeats';
        this.out = null;
        this.v = empty;
    }
    DropRepeatsOperator.prototype._start = function (out) {
        this.out = out;
        this.ins._add(this);
    };
    DropRepeatsOperator.prototype._stop = function () {
        this.ins._remove(this);
        this.out = null;
        this.v = empty;
    };
    DropRepeatsOperator.prototype.isEq = function (x, y) {
        return this.fn ? this.fn(x, y) : x === y;
    };
    DropRepeatsOperator.prototype._n = function (t) {
        var u = this.out;
        if (!u)
            return;
        var v = this.v;
        if (v !== empty && this.isEq(t, v))
            return;
        this.v = t;
        u._n(t);
    };
    DropRepeatsOperator.prototype._e = function (err) {
        var u = this.out;
        if (!u)
            return;
        u._e(err);
    };
    DropRepeatsOperator.prototype._c = function () {
        var u = this.out;
        if (!u)
            return;
        u._c();
    };
    return DropRepeatsOperator;
}());
exports.DropRepeatsOperator = DropRepeatsOperator;
/**
 * Drops consecutive duplicate values in a stream.
 *
 * Marble diagram:
 *
 * ```text
 * --1--2--1--1--1--2--3--4--3--3|
 *     dropRepeats
 * --1--2--1--------2--3--4--3---|
 * ```
 *
 * Example:
 *
 * ```js
 * import dropRepeats from 'xstream/extra/dropRepeats'
 *
 * const stream = xs.of(1, 2, 1, 1, 1, 2, 3, 4, 3, 3)
 *   .compose(dropRepeats())
 *
 * stream.addListener({
 *   next: i => console.log(i),
 *   error: err => console.error(err),
 *   complete: () => console.log('completed')
 * })
 * ```
 *
 * ```text
 * > 1
 * > 2
 * > 1
 * > 2
 * > 3
 * > 4
 * > 3
 * > completed
 * ```
 *
 * Example with a custom isEqual function:
 *
 * ```js
 * import dropRepeats from 'xstream/extra/dropRepeats'
 *
 * const stream = xs.of('a', 'b', 'a', 'A', 'B', 'b')
 *   .compose(dropRepeats((x, y) => x.toLowerCase() === y.toLowerCase()))
 *
 * stream.addListener({
 *   next: i => console.log(i),
 *   error: err => console.error(err),
 *   complete: () => console.log('completed')
 * })
 * ```
 *
 * ```text
 * > a
 * > b
 * > a
 * > B
 * > completed
 * ```
 *
 * @param {Function} isEqual An optional function of type
 * `(x: T, y: T) => boolean` that takes an event from the input stream and
 * checks if it is equal to previous event, by returning a boolean.
 * @return {Stream}
 */
function dropRepeats(isEqual) {
    if (isEqual === void 0) { isEqual = void 0; }
    return function dropRepeatsOperator(ins) {
        return new index_1.Stream(new DropRepeatsOperator(ins, isEqual));
    };
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = dropRepeats;
//# sourceMappingURL=dropRepeats.js.map

/***/ }),

/***/ "../../../node_modules/xstream/extra/fromEvent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var index_1 = __webpack_require__("../../../node_modules/xstream/index.js");
var DOMEventProducer = (function () {
    function DOMEventProducer(node, eventType, useCapture) {
        this.node = node;
        this.eventType = eventType;
        this.useCapture = useCapture;
        this.type = 'fromEvent';
    }
    DOMEventProducer.prototype._start = function (out) {
        this.listener = function (e) { return out._n(e); };
        this.node.addEventListener(this.eventType, this.listener, this.useCapture);
    };
    DOMEventProducer.prototype._stop = function () {
        this.node.removeEventListener(this.eventType, this.listener, this.useCapture);
        this.listener = null;
    };
    return DOMEventProducer;
}());
exports.DOMEventProducer = DOMEventProducer;
var NodeEventProducer = (function () {
    function NodeEventProducer(node, eventName) {
        this.node = node;
        this.eventName = eventName;
        this.type = 'fromEvent';
    }
    NodeEventProducer.prototype._start = function (out) {
        this.listener = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return (args.length > 1) ? out._n(args) : out._n(args[0]);
        };
        this.node.addListener(this.eventName, this.listener);
    };
    NodeEventProducer.prototype._stop = function () {
        this.node.removeListener(this.eventName, this.listener);
        this.listener = null;
    };
    return NodeEventProducer;
}());
exports.NodeEventProducer = NodeEventProducer;
function isEmitter(element) {
    return element.emit && element.addListener;
}
/**
 * Creates a stream based on either:
 * - DOM events with the name `eventName` from a provided target node
 * - Events with the name `eventName` from a provided NodeJS EventEmitter
 *
 * When creating a stream from EventEmitters, if the source event has more than
 * one argument all the arguments will be aggregated into an array in the
 * result stream.
 *
 * Marble diagram:
 *
 * ```text
 *   fromEvent(element, eventName)
 * ---ev--ev----ev---------------
 * ```
 *
 * Examples:
 *
 * ```js
 * import fromEvent from 'xstream/extra/fromEvent'
 *
 * const stream = fromEvent(document.querySelector('.button'), 'click')
 *   .mapTo('Button clicked!')
 *
 * stream.addListener({
 *   next: i => console.log(i),
 *   error: err => console.error(err),
 *   complete: () => console.log('completed')
 * })
 * ```
 *
 * ```text
 * > 'Button clicked!'
 * > 'Button clicked!'
 * > 'Button clicked!'
 * ```
 *
 * ```js
 * import fromEvent from 'xstream/extra/fromEvent'
 * import {EventEmitter} from 'events'
 *
 * const MyEmitter = new EventEmitter()
 * const stream = fromEvent(MyEmitter, 'foo')
 *
 * stream.addListener({
 *   next: i => console.log(i),
 *   error: err => console.error(err),
 *   complete: () => console.log('completed')
 * })
 *
 * MyEmitter.emit('foo', 'bar')
 * ```
 *
 * ```text
 * > 'bar'
 * ```
 *
 * ```js
 * import fromEvent from 'xstream/extra/fromEvent'
 * import {EventEmitter} from 'events'
 *
 * const MyEmitter = new EventEmitter()
 * const stream = fromEvent(MyEmitter, 'foo')
 *
 * stream.addListener({
 *   next: i => console.log(i),
 *   error: err => console.error(err),
 *   complete: () => console.log('completed')
 * })
 *
 * MyEmitter.emit('foo', 'bar', 'baz', 'buzz')
 * ```
 *
 * ```text
 * > ['bar', 'baz', 'buzz']
 * ```
 *
 * @param {EventTarget|EventEmitter} element The element upon which to listen.
 * @param {string} eventName The name of the event for which to listen.
 * @param {boolean?} useCapture An optional boolean that indicates that events of
 * this type will be dispatched to the registered listener before being
 * dispatched to any EventTarget beneath it in the DOM tree. Defaults to false.
 * @return {Stream}
 */
function fromEvent(element, eventName, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    if (isEmitter(element)) {
        return new index_1.Stream(new NodeEventProducer(element, eventName));
    }
    else {
        return new index_1.Stream(new DOMEventProducer(element, eventName, useCapture));
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = fromEvent;
//# sourceMappingURL=fromEvent.js.map

/***/ }),

/***/ "../../../node_modules/xstream/extra/sampleCombine.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var index_1 = __webpack_require__("../../../node_modules/xstream/index.js");
var NO = {};
var SampleCombineListener = (function () {
    function SampleCombineListener(i, p) {
        this.i = i;
        this.p = p;
        p.ils[i] = this;
    }
    SampleCombineListener.prototype._n = function (t) {
        var p = this.p;
        if (p.out === NO)
            return;
        p.up(t, this.i);
    };
    SampleCombineListener.prototype._e = function (err) {
        this.p._e(err);
    };
    SampleCombineListener.prototype._c = function () {
        this.p.down(this.i, this);
    };
    return SampleCombineListener;
}());
exports.SampleCombineListener = SampleCombineListener;
var SampleCombineOperator = (function () {
    function SampleCombineOperator(ins, streams) {
        this.type = 'sampleCombine';
        this.ins = ins;
        this.others = streams;
        this.out = NO;
        this.ils = [];
        this.Nn = 0;
        this.vals = [];
    }
    SampleCombineOperator.prototype._start = function (out) {
        this.out = out;
        var s = this.others;
        var n = this.Nn = s.length;
        var vals = this.vals = new Array(n);
        for (var i = 0; i < n; i++) {
            vals[i] = NO;
            s[i]._add(new SampleCombineListener(i, this));
        }
        this.ins._add(this);
    };
    SampleCombineOperator.prototype._stop = function () {
        var s = this.others;
        var n = s.length;
        var ils = this.ils;
        this.ins._remove(this);
        for (var i = 0; i < n; i++) {
            s[i]._remove(ils[i]);
        }
        this.out = NO;
        this.vals = [];
        this.ils = [];
    };
    SampleCombineOperator.prototype._n = function (t) {
        var out = this.out;
        if (out === NO)
            return;
        if (this.Nn > 0)
            return;
        out._n([t].concat(this.vals));
    };
    SampleCombineOperator.prototype._e = function (err) {
        var out = this.out;
        if (out === NO)
            return;
        out._e(err);
    };
    SampleCombineOperator.prototype._c = function () {
        var out = this.out;
        if (out === NO)
            return;
        out._c();
    };
    SampleCombineOperator.prototype.up = function (t, i) {
        var v = this.vals[i];
        if (this.Nn > 0 && v === NO) {
            this.Nn--;
        }
        this.vals[i] = t;
    };
    SampleCombineOperator.prototype.down = function (i, l) {
        this.others[i]._remove(l);
    };
    return SampleCombineOperator;
}());
exports.SampleCombineOperator = SampleCombineOperator;
var sampleCombine;
/**
 *
 * Combines a source stream with multiple other streams. The result stream
 * will emit the latest events from all input streams, but only when the
 * source stream emits.
 *
 * If the source, or any input stream, throws an error, the result stream
 * will propagate the error. If any input streams end, their final emitted
 * value will remain in the array of any subsequent events from the result
 * stream.
 *
 * The result stream will only complete upon completion of the source stream.
 *
 * Marble diagram:
 *
 * ```text
 * --1----2-----3--------4--- (source)
 * ----a-----b-----c--d------ (other)
 *      sampleCombine
 * -------2a----3b-------4d--
 * ```
 *
 * Examples:
 *
 * ```js
 * import sampleCombine from 'xstream/extra/sampleCombine'
 * import xs from 'xstream'
 *
 * const sampler = xs.periodic(1000).take(3)
 * const other = xs.periodic(100)
 *
 * const stream = sampler.compose(sampleCombine(other))
 *
 * stream.addListener({
 *   next: i => console.log(i),
 *   error: err => console.error(err),
 *   complete: () => console.log('completed')
 * })
 * ```
 *
 * ```text
 * > [0, 8]
 * > [1, 18]
 * > [2, 28]
 * ```
 *
 * ```js
 * import sampleCombine from 'xstream/extra/sampleCombine'
 * import xs from 'xstream'
 *
 * const sampler = xs.periodic(1000).take(3)
 * const other = xs.periodic(100).take(2)
 *
 * const stream = sampler.compose(sampleCombine(other))
 *
 * stream.addListener({
 *   next: i => console.log(i),
 *   error: err => console.error(err),
 *   complete: () => console.log('completed')
 * })
 * ```
 *
 * ```text
 * > [0, 1]
 * > [1, 1]
 * > [2, 1]
 * ```
 *
 * @param {...Stream} streams One or more streams to combine with the sampler
 * stream.
 * @return {Stream}
 */
sampleCombine = function sampleCombine() {
    var streams = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        streams[_i] = arguments[_i];
    }
    return function sampleCombineOperator(sampler) {
        return new index_1.Stream(new SampleCombineOperator(sampler, streams));
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = sampleCombine;
//# sourceMappingURL=sampleCombine.js.map

/***/ }),

/***/ "./cards/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Cards */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("../../../node_modules/babel-runtime/helpers/slicedToArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xstream_extra_sampleCombine__ = __webpack_require__("../../../node_modules/xstream/extra/sampleCombine.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xstream_extra_sampleCombine___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_xstream_extra_sampleCombine__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xstream__ = __webpack_require__("../../../node_modules/xstream/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xstream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_xstream__);
function Cards(_ref){var DOM=_ref.DOM;var cardElement$=DOM.element();var init$=cardElement$.take(1).map(function(card){return function(){card.classList.remove('-opened');card.classList.add('-closed');};});var toggleCard$=DOM.select('[data-carditem-togglecontent]').events('click').compose(__WEBPACK_IMPORTED_MODULE_1_xstream_extra_sampleCombine___default()(cardElement$)).map(function(_ref2){var _ref3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2,2),card=_ref3[1];return function(){card.classList.toggle('-opened');card.classList.toggle('-closed');};});return{DOM:__WEBPACK_IMPORTED_MODULE_2_xstream___default.a.merge(init$,toggleCard$)};}/* harmony default export */ __webpack_exports__["a"] = (Cards);

/***/ }),

/***/ "./drivers/DOMmutationDriver.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = jqueryDriver;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("../../../node_modules/babel-runtime/helpers/toConsumableArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent__ = __webpack_require__("../../../node_modules/xstream/extra/fromEvent.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xstream__ = __webpack_require__("../../../node_modules/xstream/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xstream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_xstream__);
function jqueryDriver(){return function(instruction$){instruction$.addListener({next:function next(fn){if(typeof fn==='function'){fn();}else{fn.call();}},error:function error(err){throw err;},complete:function complete(){}});var attachListeners$=instruction$.filter(function(_ref){var reAttachListeners=_ref.reAttachListeners;return!!reAttachListeners;}).startWith('');return api({path:'',selector:'',root:document});function api(_ref2){var _ref2$path=_ref2.path,path=_ref2$path===undefined?'':_ref2$path,_ref2$selector=_ref2.selector,selector=_ref2$selector===undefined?'':_ref2$selector,_ref2$root=_ref2.root,root=_ref2$root===undefined?document:_ref2$root;function getElements(selector_){if(!selector_)return[root];return[].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(root.querySelectorAll(selector_)));}return{scope:function scope(selector_,fn){var sel=(selector+' '+selector_).trim();var path_=(path+' '+sel).trim();return __WEBPACK_IMPORTED_MODULE_2_xstream___default.a.merge.apply(__WEBPACK_IMPORTED_MODULE_2_xstream___default.a,__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(getElements(sel).map(function(x){return fn(api({selector:'',root:x,path:path_}));})));},select:function select(selector_){var sel=(selector+' '+selector_).trim();var path_=(path+' '+sel).trim();return api({selector:sel,root:root,path:path_});},events:function events(event){return attachListeners$.map(function(){return getElements(selector);}).map(function(els){return els.map(function(el){return __WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent___default()(el,event);});}).map(function(ev$s){return __WEBPACK_IMPORTED_MODULE_2_xstream___default.a.merge.apply(__WEBPACK_IMPORTED_MODULE_2_xstream___default.a,__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(ev$s));}).flatten();},elements:function elements(){return attachListeners$.map(function(){return getElements(selector);});},element:function element(){return attachListeners$.map(function(){return getElements(selector)[0];});},window:function(_window){function window(){return _window.apply(this,arguments);}window.toString=function(){return _window.toString();};return window;}(function(){return{element:function element(){return __WEBPACK_IMPORTED_MODULE_2_xstream___default.a.of(window);},elements:function elements(){return __WEBPACK_IMPORTED_MODULE_2_xstream___default.a.of([window]);},events:function events(event){return __WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent___default()(window,event);}};})};}};}

/***/ }),

/***/ "./drivers/interactionDriver.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeInteractionDriver;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_xstream_extra_dropRepeats__ = __webpack_require__("../../../node_modules/xstream/extra/dropRepeats.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_xstream_extra_dropRepeats___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_xstream_extra_dropRepeats__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent__ = __webpack_require__("../../../node_modules/xstream/extra/fromEvent.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xstream__ = __webpack_require__("../../../node_modules/xstream/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xstream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_xstream__);
function makeInteractionDriver(element){return function(){return{size:function size(){return __WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent___default()(window,'resize').startWith({}).map(function(){return{width:element.innerWidth||element.width,height:element.innerHeight||element.height};}).remember();},scroll:function scroll(){return __WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent___default()(element,'scroll').map(function(){return{top:element.scrollTop,left:element.scrollLeft};}).remember();},mouseMove:function mouseMove(){return __WEBPACK_IMPORTED_MODULE_2_xstream___default.a.merge(__WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent___default()(element,'mousemove'),__WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent___default()(element,'touchmove').map(function(evt){return evt.changedTouches[0];}),__WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent___default()(element,'touchend').map(function(evt){return evt.changedTouches[0];}),__WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent___default()(element,'touchstart').map(function(evt){return evt.changedTouches[0];})).compose(__WEBPACK_IMPORTED_MODULE_0_xstream_extra_dropRepeats___default()());},mouseUp:function mouseUp(){return __WEBPACK_IMPORTED_MODULE_2_xstream___default.a.merge(__WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent___default()(element,'mouseup'),__WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent___default()(element,'touchend').map(function(evt){return evt.changedTouches[0];})).compose(__WEBPACK_IMPORTED_MODULE_0_xstream_extra_dropRepeats___default()()).remember();},mouseDown:function mouseDown(){return __WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent___default()(element,'mousedown').compose(__WEBPACK_IMPORTED_MODULE_0_xstream_extra_dropRepeats___default()()).remember();},doubleClick:function doubleClick(){return __WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent___default()(element,'dblclick').compose(__WEBPACK_IMPORTED_MODULE_0_xstream_extra_dropRepeats___default()()).remember();},mouseLeave:function mouseLeave(){return __WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent___default()(element,'mouseleave').remember();},keyDown:function keyDown(){return __WEBPACK_IMPORTED_MODULE_1_xstream_extra_fromEvent___default()(element,'keydown').remember();}};};}

/***/ }),

/***/ "./index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("./main.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cycle_run__ = __webpack_require__("../../../node_modules/@cycle/run/lib/es6/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cycle_time__ = __webpack_require__("../../../node_modules/@cycle/time/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cycle_time___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__cycle_time__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__drivers_interactionDriver__ = __webpack_require__("./drivers/interactionDriver.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__drivers_DOMmutationDriver__ = __webpack_require__("./drivers/DOMmutationDriver.js");
/*
 * helpers
 */// import './verticalGrid'
document.documentElement.classList.remove('_nojs');document.documentElement.classList.add('ontouchstart'in document.documentElement?'_touch':'_notouch');/*
 * Application
 */var drivers={Screen:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__drivers_interactionDriver__["a" /* default */])(window),DOM:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__drivers_DOMmutationDriver__["a" /* default */])(window),Time:__WEBPACK_IMPORTED_MODULE_2__cycle_time__["timeDriver"]};__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cycle_run__["run"])(__WEBPACK_IMPORTED_MODULE_0__main__["a" /* main */],drivers);

/***/ }),

/***/ "./main.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = main;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("../../../node_modules/babel-runtime/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rowSlider__ = __webpack_require__("./rowSlider/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slider__ = __webpack_require__("./slider/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cards__ = __webpack_require__("./cards/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xstream__ = __webpack_require__("../../../node_modules/xstream/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xstream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_xstream__);
function main(sources){var cards=sources.DOM.scope('[data-carditem]',function(DOM){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cards__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({},sources,{DOM:DOM})).DOM;});var rowSliders=sources.DOM.scope('[data-rowslider]',function(DOM){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__rowSlider__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({},sources,{DOM:DOM})).DOM;});var wordsSlider=sources.DOM.scope('[data-wordsslider]',function(DOM){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__slider__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({},sources,{DOM:DOM})).DOM;});var imagesSlider=sources.DOM.scope('[data-imagesslider]',function(DOM){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__slider__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({},sources,{DOM:DOM})).DOM;});return{DOM:__WEBPACK_IMPORTED_MODULE_4_xstream___default.a.merge(cards,rowSliders,wordsSlider,imagesSlider)};}/* unused harmony default export */ var _unused_webpack_default_export = (main);

/***/ }),

/***/ "./rowSlider/actions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export autoScroll */
/* unused harmony export scrollLoop */
/* unused harmony export toggleScrollable */
/* unused harmony export resetScroll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("../../../node_modules/babel-runtime/helpers/slicedToArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
function init(_ref){var _ref2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref,2),$row=_ref2[0],$scroller=_ref2[1];return{call:function call(){$scroller.appendChild($row.cloneNode(true));$scroller.appendChild($row.cloneNode(true));$scroller.appendChild($row.cloneNode(true));$scroller.appendChild($row.cloneNode(true));},reAttachListeners:true};}function autoScroll(_ref3){var _ref4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3,3),pos=_ref4[0],$rows=_ref4[1],rowWidth=_ref4[2];return function(){return $rows.forEach(function($row){$row.style.transform='translateX(-'+(rowWidth+pos%rowWidth)+'px)';});};}function scrollLoop(_ref5){var _ref6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref5,3),rowWidth=_ref6[0],scrollLeft=_ref6[1],$scroller=_ref6[2];return function(){return $scroller.scrollLeft=rowWidth+scrollLeft%rowWidth;};}function toggleScrollable(_ref7){var _ref8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref7,2),$element=_ref8[0],isScrollable=_ref8[1];return function(){if(isScrollable){$element.classList.add('-scrollable');$element.classList.remove('-largeenough');}else{$element.classList.remove('-scrollable');$element.classList.add('-largeenough');}};}function resetScroll(_ref9){var _ref10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref9,2),$rows=_ref10[0],$scroller=_ref10[1];return function(){$rows.forEach(function($row){$row.style.transform='translateX(0px)';});$scroller.scrollLeft=0;};}/* harmony default export */ __webpack_exports__["a"] = ({init:init,autoScroll:autoScroll,scrollLoop:scrollLoop,toggleScrollable:toggleScrollable,resetScroll:resetScroll});

/***/ }),

/***/ "./rowSlider/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RowSlider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray__ = __webpack_require__("../../../node_modules/babel-runtime/helpers/toArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("../../../node_modules/babel-runtime/helpers/slicedToArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xstream_extra_concat__ = __webpack_require__("../../../node_modules/xstream/extra/concat.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xstream_extra_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_xstream_extra_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("./rowSlider/actions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__intent__ = __webpack_require__("./rowSlider/intent.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model__ = __webpack_require__("./rowSlider/model.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_xstream__ = __webpack_require__("../../../node_modules/xstream/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_xstream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_xstream__);
function RowSlider(_ref){var DOM=_ref.DOM,Time=_ref.Time;var element$=DOM.element();var row$=DOM.select('[data-rowslider-row]').element();var rows$=DOM.select('[data-rowslider-row]').elements();var scroller$=DOM.select('[data-rowslider-scroller]').element();var receptacle$=DOM.select('[data-rowslider-receptacle]').element();var intents=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__intent__["a" /* default */])({DOM:DOM,Time:Time});var position$=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__model__["a" /* default */])(intents);var rowWidth$=intents.resize$.startWith({}).mapTo(row$).flatten().map(function(_ref2){var clientWidth=_ref2.clientWidth;return clientWidth;});var init$=__WEBPACK_IMPORTED_MODULE_6_xstream___default.a.combine(row$,scroller$).take(1).map(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */].init);var autoScroll$=__WEBPACK_IMPORTED_MODULE_6_xstream___default.a.combine(intents.isScrollable$,position$,rows$,rowWidth$).filter(function(_ref3){var _ref4=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3,1),isScrollable=_ref4[0];return isScrollable;}).map(function(_ref5){var _ref6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray___default()(_ref5),rest=_ref6.slice(1);return rest;}).map(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */].autoScroll);var scrollLoop$=__WEBPACK_IMPORTED_MODULE_6_xstream___default.a.combine(intents.isScrollable$,rowWidth$,intents.scrollLeft$,scroller$).filter(function(_ref7){var _ref8=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref7,3),isScrollable=_ref8[0],rowWidth=_ref8[1],scrollLeft=_ref8[2];return isScrollable&&scrollLeft>rowWidth||scrollLeft<rowWidth;}).map(function(_ref9){var _ref10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray___default()(_ref9),rest=_ref10.slice(1);return rest;}).map(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */].scrollLoop);var makeScrollable$=__WEBPACK_IMPORTED_MODULE_6_xstream___default.a.combine(element$,intents.isScrollable$).map(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */].toggleScrollable);var resetScroll$=intents.isScrollable$.filter(function(x){return!x;}).map(function(){return __WEBPACK_IMPORTED_MODULE_6_xstream___default.a.combine(rows$,scroller$);}).flatten().map(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */].resetScroll);return{DOM:__WEBPACK_IMPORTED_MODULE_2_xstream_extra_concat___default()(init$,__WEBPACK_IMPORTED_MODULE_6_xstream___default.a.merge(makeScrollable$,resetScroll$,autoScroll$,scrollLoop$))};}/* harmony default export */ __webpack_exports__["a"] = (RowSlider);

/***/ }),

/***/ "./rowSlider/intent.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export intent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("../../../node_modules/babel-runtime/helpers/slicedToArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xstream__ = __webpack_require__("../../../node_modules/xstream/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xstream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_xstream__);
function intent(_ref){var Time=_ref.Time,DOM=_ref.DOM;var _params=params(DOM),defaultAcceleration$=_params.speed$;var scroller=DOM.select('[data-rowslider-scroller]');var scroller$=scroller.element();var row$=DOM.select('[data-rowslider-row]').element();var logos=DOM.select('[data-rowslider-element]');var mouseenter$=logos.events('mouseenter');var mouseleave$=logos.events('mouseleave');var mouseTrigger$=__WEBPACK_IMPORTED_MODULE_1_xstream___default.a.merge(mouseenter$.mapTo(true),mouseleave$.mapTo(false)).compose(Time.debounce(100)).startWith(false);var focus$=logos.events('focus');var blur$=logos.events('blur');var focusTrigger$=__WEBPACK_IMPORTED_MODULE_1_xstream___default.a.merge(focus$.map(function(x){return x.target;}),blur$.mapTo(false)).startWith(false);var scrollStart$=scroller.events('scroll').compose(Time.throttleAnimation);var scrollEnd$=scrollStart$.compose(Time.debounce(25));var isScrolling$=__WEBPACK_IMPORTED_MODULE_1_xstream___default.a.merge(scrollStart$.mapTo(true),scrollEnd$.mapTo(false)).startWith(false);var pause$=__WEBPACK_IMPORTED_MODULE_1_xstream___default.a.combine(mouseTrigger$,focusTrigger$,isScrolling$).map(function(_ref2){var _ref3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2,3),mouse=_ref3[0],focus=_ref3[1],scrolling=_ref3[2];return mouse||focus||scrolling;}).startWith(false);var resize$=DOM.window().events('resize');var slideLeft$=slideButtonIntent({Time:Time,DOM:DOM},'[data-rowslider-slide-left]');var slideRight$=slideButtonIntent({Time:Time,DOM:DOM},'[data-rowslider-slide-right]');var scrollLeft$=scrollStart$.map(function(x){return x.target.scrollLeft;});var deltaTime$=Time.animationFrames().map(function(_ref4){var delta=_ref4.delta;return delta;});var normalizedDeltaTime$=Time.animationFrames().map(function(_ref5){var normalizedDelta=_ref5.normalizedDelta;return normalizedDelta;});var isScrollable$=resize$.startWith({}).compose(Time.throttleAnimation).map(function(){return __WEBPACK_IMPORTED_MODULE_1_xstream___default.a.combine(scroller$,row$);}).flatten().map(function(_ref6){var _ref7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref6,2),scroller=_ref7[0],row=_ref7[1];var _window$getComputedSt=window.getComputedStyle(scroller),paddingLeft=_window$getComputedSt.paddingLeft,paddingRight=_window$getComputedSt.paddingRight;var innerWidth=scroller.clientWidth-parseFloat(paddingLeft)-parseFloat(paddingRight);return row.clientWidth>innerWidth;});return{normalizedDeltaTime$:normalizedDeltaTime$,defaultAcceleration$:defaultAcceleration$,isScrollable$:isScrollable$,scrollLeft$:scrollLeft$,slideRight$:slideRight$,slideLeft$:slideLeft$,deltaTime$:deltaTime$,resize$:resize$,pause$:pause$};}/* harmony default export */ __webpack_exports__["a"] = (intent);function slideButtonIntent(_ref8,selector){var Time=_ref8.Time,DOM=_ref8.DOM;return __WEBPACK_IMPORTED_MODULE_1_xstream___default.a.merge(DOM.select(selector).events('click').mapTo(true),DOM.select(selector).events('mousedown').mapTo(true),DOM.select(selector).events('mouseup').compose(Time.delay(1)).mapTo(false),DOM.select(selector).events('mouseleave').mapTo(false),DOM.select(selector).events('blur').mapTo(false)).startWith(false);}function params(DOMElement){var params$=DOMElement.element().map(function(x){return x.getAttribute('data-rowslider');}).map(function(x){return JSON.parse(x)||{};});return{speed$:params$.map(function(x){return parseFloat(x.speed);}).map(function(x){return!x&&x!=0?1:x;})// default to 1 if x is not a number
};}

/***/ }),

/***/ "./rowSlider/model.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export model */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("../../../node_modules/babel-runtime/helpers/slicedToArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xstream_extra_sampleCombine__ = __webpack_require__("../../../node_modules/xstream/extra/sampleCombine.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xstream_extra_sampleCombine___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_xstream_extra_sampleCombine__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xstream__ = __webpack_require__("../../../node_modules/xstream/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xstream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_xstream__);
function model(_ref){var pause$=_ref.pause$,slideRight$=_ref.slideRight$,slideLeft$=_ref.slideLeft$,normalizedDeltaTime$=_ref.normalizedDeltaTime$,deltaTime$=_ref.deltaTime$,defaultAcceleration$=_ref.defaultAcceleration$;var friction$=pause$.map(function(paused){return paused?1.25:1.01;});var acceleration$=__WEBPACK_IMPORTED_MODULE_2_xstream___default.a.combine(defaultAcceleration$,slideRight$,slideLeft$).map(function(_ref2){var _ref3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2,3),defaultAcceleration=_ref3[0],slideRight=_ref3[1],slideLeft=_ref3[2];if(slideRight&&slideLeft)return 0;if(slideRight)return 150;if(slideLeft)return-150;return defaultAcceleration;}).map(function(x){return x/1000;});var speed$=normalizedDeltaTime$.compose(__WEBPACK_IMPORTED_MODULE_1_xstream_extra_sampleCombine___default()(friction$,acceleration$)).fold(function(currentSpeed,_ref4){var _ref5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref4,3),normalizedDelta=_ref5[0],friction=_ref5[1],acceleration=_ref5[2];return Math.min((currentSpeed+acceleration/normalizedDelta)/friction,3);},0).map(function(x){return x*10;})// magic number so it's ± between 0 and 1
.map(function(x){return x*15/1000;})// max normal speed, magic number again
.map(function(x){return Math.abs(x)<2/1000?0:x;});// prevents to move when speed is really low, magic number again
var position$=__WEBPACK_IMPORTED_MODULE_2_xstream___default.a.combine(deltaTime$,speed$).fold(function(pos,_ref6){var _ref7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref6,2),delta=_ref7[0],speed=_ref7[1];return pos+speed*delta;},0);return position$;}/* harmony default export */ __webpack_exports__["a"] = (model);

/***/ }),

/***/ "./slider/actions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export setVisible */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set_immediate__ = __webpack_require__("../../../node_modules/babel-runtime/core-js/set-immediate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set_immediate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set_immediate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("../../../node_modules/babel-runtime/helpers/slicedToArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
function init(_ref){var _ref2=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref,2),$slider=_ref2[0],$slides=_ref2[1];return function(){$slider.classList.add('-animated');$slides.forEach(function($slide,index){return index==0?$slide.classList.add('-visible','-noanimation'):$slide.classList.add('-hidden','-noanimation');});__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set_immediate___default()(function(){return $slides.forEach(function($slide,index){return index==0?$slide.classList.remove('-noanimation'):$slide.classList.remove('-noanimation');});});};}function setVisible(_ref3){var _ref4=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3,2),$slides=_ref4[0],index=_ref4[1];return function(){return $slides.forEach(function($slide,index_){return index==index_?($slide.classList.add('-visible'),$slide.classList.remove('-hidden')):($slide.classList.add('-hidden'),$slide.classList.remove('-visible'));});};}/* harmony default export */ __webpack_exports__["a"] = ({init:init,setVisible:setVisible});

/***/ }),

/***/ "./slider/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Slider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("../../../node_modules/babel-runtime/helpers/slicedToArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xstream_extra_concat__ = __webpack_require__("../../../node_modules/xstream/extra/concat.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xstream_extra_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_xstream_extra_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("./slider/actions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__intent__ = __webpack_require__("./slider/intent.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xstream__ = __webpack_require__("../../../node_modules/xstream/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xstream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_xstream__);
function Slider(_ref){var DOM=_ref.DOM,Time=_ref.Time;var element$=DOM.element();var slides$=DOM.select('[data-slider-slide]').elements();var intents=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__intent__["a" /* default */])({DOM:DOM,Time:Time});var index$=__WEBPACK_IMPORTED_MODULE_4_xstream___default.a.merge(intents.next$.mapTo(+1),intents.prev$.mapTo(-1),intents.goto$.map(function(index){return{type:'goto',index:index};})).fold(function(curr,iter){return iter.type=='goto'?iter.index:curr+iter;},0);var init$=__WEBPACK_IMPORTED_MODULE_4_xstream___default.a.combine(element$,slides$).take(1).map(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */].init);var slideto$=__WEBPACK_IMPORTED_MODULE_4_xstream___default.a.combine(slides$,index$).map(function(_ref2){var _ref3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2,2),$slides=_ref3[0],position=_ref3[1];return[$slides,position%$slides.length];}).map(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */].setVisible);return{DOM:__WEBPACK_IMPORTED_MODULE_1_xstream_extra_concat___default()(init$,__WEBPACK_IMPORTED_MODULE_4_xstream___default.a.merge(slideto$))};}/* harmony default export */ __webpack_exports__["a"] = (Slider);

/***/ }),

/***/ "./slider/intent.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export intent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("../../../node_modules/babel-runtime/helpers/slicedToArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xstream_extra_dropRepeats__ = __webpack_require__("../../../node_modules/xstream/extra/dropRepeats.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xstream_extra_dropRepeats___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_xstream_extra_dropRepeats__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xstream__ = __webpack_require__("../../../node_modules/xstream/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xstream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_xstream__);
function intent(_ref){var Time=_ref.Time,DOM=_ref.DOM;var _params=params(DOM),period$=_params.period$,autoplay$=_params.autoplay$;var prev$=__WEBPACK_IMPORTED_MODULE_2_xstream___default.a.empty();var goto$=__WEBPACK_IMPORTED_MODULE_2_xstream___default.a.of(0);var next$=__WEBPACK_IMPORTED_MODULE_2_xstream___default.a.combine(goto$,period$,autoplay$.compose(__WEBPACK_IMPORTED_MODULE_1_xstream_extra_dropRepeats___default()())).map(function(_ref2){var _ref3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2,3),period=_ref3[1],autoplay=_ref3[2];return autoplay?Time.periodic(period):__WEBPACK_IMPORTED_MODULE_2_xstream___default.a.empty();}).flatten();return{prev$:prev$,next$:next$,goto$:goto$};}/* harmony default export */ __webpack_exports__["a"] = (intent);function params(DOMElement){var params$=DOMElement.element().map(function(x){return x.getAttribute('data-slider');}).map(function(x){return x?JSON.parse(x)||{}:{};});return{period$:params$.map(function(x){return parseFloat(x.period);}).map(function(x){return x||4000;}),// default to 4s if x is not a number
autoplay$:params$.map(function(x){return x.autoplay;}).map(function(x){return x==undefined?true:x;})// default to true if not defined
};}

/***/ })

},["./index.js"]);


// WEBPACK FOOTER //
// index.js